import pb from './pocketbaseClient';

/**
 * Quote number format: Q<counter>  (e.g. Q99101)
 * Version format:     Q<counter>/<n>  (e.g. Q99101/1, Q99101/2)
 */
export async function generateQuoteNumber(clientJobId, isNewVersion = false, previousNumber = null) {
  // Version (Q99101/1, Q99101/2)
  if (isNewVersion && previousNumber) {
    const baseNumber = previousNumber.split('/')[0];
    const existing = await pb.collection('quotations').getFullList({
      filter: `quoteNumber ~ "${baseNumber}"`,
      sort: '-created',
    });
    let maxVersion = 0;
    for (const q of existing) {
      const parts = q.quoteNumber.split('/');
      if (parts.length > 1) {
        const v = parseInt(parts[1], 10);
        if (!isNaN(v) && v > maxVersion) maxVersion = v;
      }
    }
    return `${baseNumber}/${maxVersion + 1}`;
  }

  // Brand new quote — find max existing Q-number
  const existing = await pb.collection('quotations').getFullList({
    filter: 'quoteNumber ~ "Q"',
    sort: '-quoteNumber',
  });

  let maxNum = 99100;
  for (const q of existing) {
    const base = q.quoteNumber.split('/')[0];
    const m = base.match(/^Q(\d+)$/);
    if (m) {
      const n = parseInt(m[1], 10);
      if (!isNaN(n) && n > maxNum) maxNum = n;
    }
  }
  return `Q${maxNum + 1}`;
}

/**
 * Invoice number format: INV-<counter>  (e.g. INV-99101)
 */
export async function generateInvoiceNumber() {
  const existing = await pb.collection('invoices').getFullList({
    filter: 'invoiceNumber ~ "INV-"',
    sort: '-invoiceNumber',
  });

  let maxNum = 99100;
  for (const inv of existing) {
    const m = inv.invoiceNumber.match(/^INV-(\d+)$/);
    if (m) {
      const n = parseInt(m[1], 10);
      if (!isNaN(n) && n > maxNum) maxNum = n;
    }
  }
  return `INV-${maxNum + 1}`;
}
